var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4766 3.22467C14.6048 1.82295 16.1779 1.0253 17.8661 1H17.9912C21.1305 1 23.9711 4.04295 24.0182 8.10867C24.0258 8.8839 23.93 9.633 23.7373 10.3406L23.7262 10.3815L23.7185 10.4233C23.5781 11.1906 23.0264 12.2736 21.8752 13.7112C20.7411 15.1274 19.0983 16.7991 16.9132 18.7394L16.9128 18.7397C15.2285 20.2367 13.9009 21.3214 12.9407 21.9858C12.9383 21.9841 12.9363 21.9826 12.9345 21.9812L12.9314 21.9789L12.625 21.7485L12.624 21.7477L12.5461 21.6891C11.73 21.074 10.0168 19.783 8.87112 18.8232C6.59961 16.911 4.91712 15.2925 3.75607 13.9121C2.58297 12.5175 2.01014 11.4446 1.83816 10.6245L1.82853 10.5786L1.81464 10.5338C1.62948 9.93631 1.51706 9.19757 1.50934 8.41637L1.50932 8.41505C1.48627 6.35593 2.20731 4.39284 3.44407 3.0295C4.56464 1.79637 6.00296 1.14246 7.48765 1.13404C9.21379 1.13481 10.7916 1.89482 11.9345 3.24403L12.7173 4.16807L13.4766 3.22467Z",
    stroke: "#F57D7D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutline);
export default __webpack_public_path__ + "static/media/heart-outline.07eafc3952e463a753b43f825a7c80bb.svg";
export { ForwardRef as ReactComponent };